import React from 'react';
import InsuranceCompanyList from '../components/InsuranceCompanyList';

const InsuranceCompanyListPage: React.FC = () => <InsuranceCompanyList />;

export default InsuranceCompanyListPage;
